import Alpine from "alpinejs";
import { createFocusTrap } from "focus-trap";

Alpine.magic("createFocusTrap", () => (element, options) => {
    return createFocusTrap(element, options);
});
